import React from "react";
import Cards from "../pages/card";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const useStyles = makeStyles({
  servicesContainer: {
    width: "100%",
    maxWidth: "100%",
    minHeight: "100vh",

    boxSizing: "border-box",

    background: "#353353",

    padding: "100px 7%",

    overflow: "hidden",
  },

  sectionHeading: {
    maxWidth: 1200,
    margin: "0 auto 60px",
  },

  eyebrow: {
    display: "block",

    color: "#ff4f81",

    fontSize: 14,
    fontWeight: 700,

    textTransform: "uppercase",
    letterSpacing: 3,

    marginBottom: 8,
  },

  heading: {
    position: "relative",

    display: "inline-block",

    color: "#fff",

    fontSize: 45,
    fontWeight: 800,

    margin: 0,

    letterSpacing: -1,

    "&::after": {
      content: '""',

      position: "absolute",

      left: 0,
      bottom: -12,

      width: 55,
      height: 4,

      borderRadius: 10,

      background: "#ff0055",
    },
  },

  description: {
    maxWidth: 650,

    color: "#aaa9bb",

    fontSize: 15,
    lineHeight: 1.8,

    marginTop: 25,
    marginBottom: 0,
  },

  services: {
    width: "100%",
    maxWidth: 1200,

    margin: "0 auto",

    display: "grid",

    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",

    gap: 25,

    alignItems: "stretch",
  },

  serviceCard: {
    minWidth: 0,

    height: "100%",

    transition: "transform 0.3s ease",

    "&:hover": {
      transform: "translateY(-8px)",
    },
  },

  bottom: {
    maxWidth: 1200,

    margin: "65px auto 0",

    padding: "25px 30px",

    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

    gap: 20,

    borderRadius: 15,

    background: "rgba(255, 255, 255, 0.04)",

    border: "1px solid rgba(255, 255, 255, 0.07)",
  },

  bottomText: {
    margin: 0,

    color: "#c5c4d2",

    fontSize: 15,
  },

  bottomStrong: {
    color: "#fff",
    fontWeight: 700,
  },

  contactButton: {
    display: "inline-flex",

    alignItems: "center",

    gap: 7,

    color: "#fff",

    background: "#ff0055",

    padding: "11px 20px",

    borderRadius: 30,

    textDecoration: "none",

    fontSize: 14,

    fontWeight: 600,

    whiteSpace: "nowrap",

    transition: "all 0.3s ease",

    "&:hover": {
      color: "#fff",

      background: "#ff1767",

      transform: "translateY(-2px)",

      boxShadow: "0 10px 25px rgba(255, 0, 85, 0.3)",
    },
  },

  "@media (max-width: 1000px)": {
    services: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },

    serviceCard: {
      "&:hover": {
        transform: "translateY(-5px)",
      },
    },
  },

  "@media (max-width: 650px)": {
    servicesContainer: {
      padding: "70px 20px",
    },

    sectionHeading: {
      marginBottom: 45,
    },

    heading: {
      fontSize: 36,
    },

    services: {
      gridTemplateColumns: "minmax(0, 1fr)",
      gap: 20,
    },

    bottom: {
      flexDirection: "column",

      textAlign: "center",

      marginTop: 45,

      padding: "25px 20px",
    },

    contactButton: {
      width: "100%",

      justifyContent: "center",
    },
  },
});

export default function Services() {
  const classes = useStyles();

  return (
    <section id="service" className={classes.servicesContainer}>

      {/* Section heading */}
      <div className={classes.sectionHeading}>

        <span className={classes.eyebrow}>
          What I Do
        </span>

        <h1 className={classes.heading}>
          Services
        </h1>

        <p className={classes.description}>
          I build reliable and engaging digital experiences, from
          responsive interfaces to complete full-stack applications.
        </p>

      </div>


      {/* Services */}
      <div className={classes.services}>

        <div className={classes.serviceCard}>
          <Cards
            heading="Frontend Development"
            background="#6c6ce5"
            image="https://jthemes.net/themes/html/bolby/demo/images/service-1.svg"
            para="I create responsive, accessible, and interactive interfaces with a strong focus on clean UI, smooth experiences, and maintainable code."
            tech={[
              "React",
              "Next.js",
              "TypeScript",
              "JavaScript",
              "Tailwind CSS",
            ]}
          />
        </div>


        <div className={classes.serviceCard}>
          <Cards
            heading="Full-Stack Development"
            background="#35B8B0"
            image="https://jthemes.net/themes/html/bolby/demo/images/service-2.svg"
            para="I build complete web applications, from intuitive frontend experiences to reliable APIs, databases, authentication, and backend systems."
            tech={[
              "Node.js",
              "Express",
              "Next.js",
              "REST APIs",
              "PostgreSQL",
              "MongoDB",
            ]}
          />
        </div>


        <div className={classes.serviceCard}>
          <Cards
            heading="Web Applications"
            background="#F97B8B"
            image="https://cdn2.iconfinder.com/data/icons/flat-education-icons-5/96/Writing-512.png"
            para="I transform ideas and designs into scalable web applications with responsive layouts, optimized performance, and seamless functionality across devices."
            tech={[
              "SaaS",
              "Dashboards",
              "E-commerce",
              "Landing Pages",
              "Custom Apps",
            ]}
          />
        </div>

      </div>


      {/* Bottom CTA */}
      <div className={classes.bottom}>

        <p className={classes.bottomText}>
          <span className={classes.bottomStrong}>
            Have a project in mind?
          </span>{" "}
          Let's build something great together.
        </p>

        <a
          href="mailto:laraib24@outlook.com"
          className={classes.contactButton}
        >
          Let's Talk
          <ArrowForwardIcon style={{ fontSize: 18 }} />
        </a>

      </div>

    </section>
  );
}